import { fetchDiDuimpOptions } from '../proformaPackingListSaida.helpers';
import MultiSelectFiltroOptions from './MultiSelectFiltroOptions';

type Props = {
  name: string;
  label: string;
};

function MultiSelectDiDuimp({ name, label }: Props) {
  return <MultiSelectFiltroOptions name={name} label={label} fetchOptions={fetchDiDuimpOptions} />;
}

export default MultiSelectDiDuimp;
